import { ipCountryQuery, getLanguageIso6391, getFeatureEnabled } from '@gig/magic-common';
import { CONFIG_QUERY, WALLET_CONFIG_QUERY, FEATURE_QUERY_VALUE, Feature, ACCOUNT_REQUIRES_VERIFICATION_QUERY, LANGUAGE_QUERY, SINGLE_LANGUAGE_QUERY } from '@gig/magic-messages';
import { __awaiter, __generator, __assign } from 'tslib';
import { magic } from '@gig/magic-sdk';
import { WalletView, WalletEnvironment } from '@gig/magic-wallet-types';
import { Environment } from './toolkit-config.interface.js';

var ConfigV2Service = /** @class */ (function () {
    function ConfigV2Service(config) {
        this.config = null;
        this.config = config;
        this.registerConfigQuery();
        this.registerWalletConfigQuery();
    }
    ConfigV2Service.prototype.registerConfigQuery = function () {
        var _this = this;
        var handler = function (_a) {
            var path = _a.payload;
            if (!path) {
                return null;
            }
            return path.split('.').reduce(function (acc, key) {
                if (!acc || typeof acc !== 'object') {
                    throw new Error("Invalid config path = " + [path]);
                }
                return acc[key];
            }, Object.assign({}, _this.config));
        };
        window.queryBus.subscribe(CONFIG_QUERY, handler);
    };
    ConfigV2Service.prototype.registerWalletConfigQuery = function () {
        var _this = this;
        var handler = function (_a) {
            var payload = _a.payload;
            return __awaiter(_this, void 0, void 0, function () {
                var _b, requiresVerification, language, singleLanguage, depositBonusCashierEnabled, _c, configWallet, environment, keycloak, sessionUser, isProd, HIGH_RISK_ROLE, origin, featureSetting, merchant, isFeatureEnabled, options, _d, _e, _f;
                var _g, _h;
                var _j, _k;
                return __generator(this, function (_l) {
                    switch (_l.label) {
                        case 0: return [4 /*yield*/, Promise.all([
                                window.queryBus.query(ACCOUNT_REQUIRES_VERIFICATION_QUERY),
                                window.queryBus.query(LANGUAGE_QUERY),
                                window.queryBus.query(SINGLE_LANGUAGE_QUERY),
                                getFeatureEnabled(Feature.DEPOSIT_BONUS_CASHIER),
                            ])];
                        case 1:
                            _b = _l.sent(), requiresVerification = _b[0], language = _b[1], singleLanguage = _b[2], depositBonusCashierEnabled = _b[3];
                            _c = this.config, configWallet = _c.wallet, environment = _c.environment, keycloak = _c.keycloak;
                            sessionUser = magic.session.getUser();
                            isProd = environment === Environment.PRODUCTION;
                            HIGH_RISK_ROLE = 'RG: High Risk';
                            origin = window.location.origin;
                            return [4 /*yield*/, window.queryBus.query(FEATURE_QUERY_VALUE, {
                                    slug: Feature.MERCHANT_ID,
                                })];
                        case 2:
                            featureSetting = _l.sent();
                            isFeatureEnabled = featureSetting.isApplicable && featureSetting.value;
                            if (isFeatureEnabled) {
                                merchant = featureSetting.value;
                            }
                            else if (configWallet.merchant) {
                                merchant = configWallet.merchant;
                            }
                            else {
                                merchant = '';
                            }
                            _d = [{ cssUrl: origin + window.__magic__.files.wallet, path: configWallet.path, brandId: configWallet.brandId, devcodeMerchantId: merchant, isCoreX: !!keycloak }];
                            if (!keycloak) return [3 /*break*/, 4];
                            _g = {
                                hostCoreX: keycloak.apiUrl,
                                tenantCoreX: keycloak.realm
                            };
                            return [4 /*yield*/, magic.session.getAccessToken()];
                        case 3:
                            _e = (_g.tokenCoreX = _l.sent(),
                                _g.userIdCoreX = sessionUser === null || sessionUser === void 0 ? void 0 : sessionUser.userId,
                                _g);
                            return [3 /*break*/, 5];
                        case 4:
                            _e = {};
                            _l.label = 5;
                        case 5:
                            _f = [__assign.apply(void 0, _d.concat([(_e)]))];
                            _h = { environment: isProd
                                    ? WalletEnvironment.PRODUCTION
                                    : WalletEnvironment.DEVELOPMENT, languageCode: language, locale: getLanguageIso6391(language) + "_" + (sessionUser === null || sessionUser === void 0 ? void 0 : sessionUser.country), sessionId: keycloak ? '' : sessionUser.igcToken, showErrorPages: true, compliance: (sessionUser === null || sessionUser === void 0 ? void 0 : sessionUser.agreedCompliance) || false, allowBonusCodeOnDeposit: false, translationsUrl: magic.methods.translations.getTranslationsUrl(language, isProd), tncUrl: singleLanguage
                                    ? origin + "/tnc"
                                    : origin + "/" + language + "/tnc", view: payload.view };
                            return [4 /*yield*/, this.getDisallowedWithdrawalCards(configWallet)];
                        case 6:
                            _h.disallowedWithdrawalCardTypes = _l.sent(), _h.predefinedAmounts = configWallet.predefinedAmounts, _h.validateIban = configWallet.validateIban, _h.fsOrgId = configWallet.fsOrgId, _h.showSavedVisaWithdrawalsInfo = false, _h.formatSwiftCode = false, _h.googleMapsAPIKey = (_j = configWallet.googleMaps) === null || _j === void 0 ? void 0 : _j.apiKey, _h.googleMapsAPIVersion = (_k = configWallet.googleMaps) === null || _k === void 0 ? void 0 : _k.apiVersion, _h.paymentUrl = configWallet.paymentUrl, _h.bankWithdrawalSelect = this.getBankWithdrawalSelect(configWallet);
                            return [4 /*yield*/, this.getSavedDepositCardsLimit()];
                        case 7:
                            options = __assign.apply(void 0, _f.concat([(_h.storedCardsLimit = _l.sent(), _h.disableSwiftBankIbanWithdrawals = configWallet.disableSwiftBankIbanWithdrawals, _h)]));
                            if (requiresVerification) {
                                options.disableBonusOnDeposits = true;
                            }
                            if (depositBonusCashierEnabled &&
                                (sessionUser === null || sessionUser === void 0 ? void 0 : sessionUser.roles.includes(HIGH_RISK_ROLE))) {
                                options.disableBonusOnDeposits = true;
                            }
                            if (payload.view === WalletView.DEPOSIT) {
                                options.selectedDepositMethod = payload.method;
                            }
                            if (payload.view === WalletView.WITHDRAWAL) {
                                options.selectedWithdrawalMethod = payload.method;
                            }
                            return [2 /*return*/, options];
                    }
                });
            });
        };
        window.queryBus.subscribe(WALLET_CONFIG_QUERY, handler);
    };
    ConfigV2Service.prototype.getBankWithdrawalSelect = function (configWallet) {
        try {
            return JSON.stringify(configWallet === null || configWallet === void 0 ? void 0 : configWallet.bankWithdrawalSelect);
        }
        catch (error) {
            console.error({
                message: 'Incorrect bankWithdrawalSelect value',
                error: error,
            });
            return '';
        }
    };
    ConfigV2Service.prototype.getSavedDepositCardsLimit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var savedDepositCards, savedDepositCardsLimit;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, window.queryBus.query(FEATURE_QUERY_VALUE, {
                            slug: Feature.SAVED_DEPOSIT_CARDS,
                        })];
                    case 1:
                        savedDepositCards = _a.sent();
                        if (savedDepositCards.isApplicable && savedDepositCards.value) {
                            savedDepositCardsLimit = Number(savedDepositCards.value);
                        }
                        return [2 /*return*/, savedDepositCardsLimit];
                }
            });
        });
    };
    ConfigV2Service.prototype.getDisallowedWithdrawalCards = function (configWallet) {
        return __awaiter(this, void 0, void 0, function () {
            var disallowed, currentIPCountry, disallowedCards;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        disallowed = configWallet.disallowedWithdrawalCardTypes;
                        return [4 /*yield*/, ipCountryQuery()];
                    case 1:
                        currentIPCountry = _a.sent();
                        disallowedCards = disallowed[currentIPCountry];
                        return [2 /*return*/, disallowedCards || disallowed.DEFAULT || []];
                }
            });
        });
    };
    return ConfigV2Service;
}());

export { ConfigV2Service };
